import React from 'react';
import { gql } from '@apollo/client';
import { Button } from 'antd';
import { reverse } from 'named-urls';
import { Redirect } from 'react-router-dom';
import routes from '@achievable-me/tundra-wizard/routes';
import { useQuery, useMutation } from '@apollo/react-hooks';
import MediaQuery from 'react-responsive';
import SpinnerError from '$components/library/SpinnerError';
import ExamTiles from '../ExamTiles';
import ExamTile from '../ExamTile';

const GRE_EXAMS_AVAILABLE = gql`
  query GreExamsAvailable {
    greExamsAvailable {
      issueEssays
      argumentEssays
      verbalReasoning
    }
  }
`;

const GRE_START_ESSAY = gql`
  mutation GreStartEssay($input: GreStartEssayInput!) {
    greStartEssay(input: $input) {
      essayResponse {
        uuid
      }
    }
  }
`;

const GreStartEssay = ({ type, disabled }) => {
  const [greStartEssay, { data, loading }] = useMutation(GRE_START_ESSAY);

  if (data) {
    const {
      greStartEssay: {
        essayResponse: { uuid: essayResponseUuid },
      },
    } = data;
    const essayTo = reverse(routes.study.essay, {
      productSlug: 'gre',
      essayResponseUuid,
    });
    return <Redirect push to={essayTo} />;
  }

  return (
    <React.Fragment key={`gre--${type}`}>
      <MediaQuery maxDeviceWidth={575}>
        <Button disabled>Take on desktop</Button>
      </MediaQuery>
      <MediaQuery minDeviceWidth={576}>
        <Button
          disabled={disabled}
          loading={loading}
          data-aaa={`${type}EssayLink`}
          onClick={() => greStartEssay({ variables: { input: { essayType: type } } })}
        >
          Start essay
        </Button>
      </MediaQuery>
    </React.Fragment>
  );
};

const GreExams = ({ product, disabled }) => {
  const { data, loading, error } = useQuery(GRE_EXAMS_AVAILABLE, {
    fetchPolicy: 'network-only',
  });

  if (loading || error) {
    return <SpinnerError error={error} />;
  }

  const {
    greExamsAvailable: { issueEssays, argumentEssays, verbalReasoning },
  } = data;

  return (
    <ExamTiles>
      <ExamTile
        title="Quantitative reasoning"
        length="20 questions; 35 min"
        remaining={-1}
        iconClass="fad fa-function"
        product={product}
        variant="quant"
        disabled={disabled}
      />
      <ExamTile
        title="Verbal reasoning"
        length="20 questions; 30 min"
        remaining={verbalReasoning}
        remainingWord="section"
        iconClass="fad fa-book-reader"
        product={product}
        variant="verbal"
        disabled={disabled}
      />
      <ExamTile
        title="Analytical writing (issue)"
        length="Prompted essay; 30 min"
        remaining={issueEssays}
        remainingWord="essay"
        iconClass="fad fa-keyboard"
        cta={<GreStartEssay type="issue" disabled={disabled || issueEssays === 0} />}
        disabled={disabled}
      />
      <ExamTile
        title="Analytical writing (argument)"
        length="Prompted essay; 30 min"
        remaining={argumentEssays}
        remainingWord="essay"
        iconClass="fad fa-keyboard"
        cta={
          <GreStartEssay type="argument" disabled={disabled || argumentEssays === 0} />
        }
        disabled={disabled}
      />
    </ExamTiles>
  );
};

export default GreExams;
